
import React from 'react';
import PropTypes from 'prop-types';
import Svg, { G, Path } from '@dbk/ui-svg';
import { pure } from '@dbk/ui-react-utils';

function AttachmentIcon(props) {
  const {
    color,
    ...svgProps,
  } = props;

  return (
    <Svg {...svgProps} 
            viewBox="0 0 20 25" > 
            <G id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <G id="9.Chat-2" transform="translate(-13.000000, -418.000000)" fill="#EC6B10">
                    <G id="Group" transform="translate(0.000000, 386.000000)">
                        <G id="attach" transform="translate(13.000000, 32.000000)">
                            <Path d="M4.95461538,19.7310128 C3.68526923,19.7310128 2.41592308,19.2474872 1.44911538,18.2809231 C-0.483282051,16.3482821 -0.483282051,13.2035385 1.45008974,11.2708974 L11.6399359,1.08105128 C13.053,-0.331038462 15.3510256,-0.331038462 16.7628718,1.08105128 C17.4546667,1.77284615 17.8315,2.68265385 17.8315,3.65019231 C17.8315,4.617 17.4546667,5.52753846 16.7696923,6.21178205 L7.36761538,15.6128846 L7.24289744,15.7242051 C6.44562821,16.511 5.15630769,16.5071026 4.36171795,15.7137308 L4.34271795,15.6947308 C3.96125641,15.3130256 3.74811538,14.7992949 3.74811538,14.2531667 C3.74811538,13.7077692 3.96125641,13.1940385 4.34758974,12.8077051 L9.2315641,7.92348718 C9.42205128,7.73324359 9.73019231,7.73324359 9.92067949,7.92348718 C10.1109231,8.11373077 10.1109231,8.42211538 9.92067949,8.61235897 L5.03646154,13.4965769 C4.83379487,13.6992436 4.72247436,13.9676795 4.72247436,14.2538974 C4.72247436,14.5393846 4.83379487,14.8087949 5.03646154,15.0104872 L5.05546154,15.0294872 C5.46834615,15.4423718 6.14771795,15.4423718 6.5645,15.024859 L16.0808205,5.52291026 C16.5811538,5.02233333 16.857141,4.35733333 16.857141,3.65019231 C16.857141,2.94329487 16.5811538,2.27805128 16.0808205,1.77771795 C15.0416667,0.737589744 13.3613846,0.737589744 12.3288077,1.77089744 L2.13896154,11.9600128 C0.586076923,13.5128974 0.585102564,16.040141 2.13798718,17.5920513 C3.69087179,19.1449359 6.21811538,19.1449359 7.77002564,17.5920513 L17.9598718,7.40220513 C18.150359,7.21171795 18.4585,7.21171795 18.6489872,7.40220513 C18.8392308,7.59244872 18.8392308,7.90058974 18.6489872,8.09107692 L8.45914103,18.2809231 C7.49330769,19.2474872 6.22396154,19.7310128 4.95461538,19.7310128 L4.95461538,19.7310128 Z" id="Fill-1"/>
                        </G>
                    </G>
                </G>
            </G>
        </Svg>
  );
}

AttachmentIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
};

AttachmentIcon.defaultProps = {
  height: 55,
  width: 55,
};

export default pure(AttachmentIcon);



